export default function ApiManager() {
    return {
        install: function install(Vue, {api}) {
            Vue.prototype.$api = api;
        },
    };
}
